import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useFlag } from '@duke-hq/flags/react';

export function WithReactQueryDevtools({ children }: { children: React.ReactNode }) {
  const showDevtools = useFlag('SHOW_REACT_QUERY_DEV_TOOLS_FEATURE');

  return (
    <>
      {children}
      {showDevtools === true ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </>
  );
}
